import { gql } from '@apollo/client';

export const GET_USER_PROGRESS_FOR_ALL_TAGS = gql`
  query GetUserProgressForAllTags {
    getUserProgressForAllTags {
      tag
      totalQuestions
      correctQuestions
      progress
    }
  }
`;
